import { useState } from "react";
import "./index.less";
import Button from "@/component/Button";
import { Origin } from "@/constants/share";

interface PassWordProps {
  fromsource: Origin;
  onFinished: (password: string) => void;
}

const PassWord = (props: PassWordProps) => {
  const { fromsource, onFinished } = props;

  const [inputPassword, setInputPassword] = useState("");

  const handleInputPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value.replace(/[^\d]/g, "");
    setInputPassword(v);
  };

  const handleGo = () => {
    if (!inputPassword) {
      return;
    }
    onFinished(inputPassword);
  };

  return (
    <div className="password-page">
      <div className="title">{`输入密码${fromsource === Origin.MEETING_PLATE ? "获取" : "查看"}文件`}</div>
      <input type="text" placeholder="请输入密码" value={inputPassword} onInput={handleInputPassword} minLength={1} maxLength={8} />
      <Button className={`button ${inputPassword ? "" : "disabled"}`} onClick={() => handleGo()}>
        前往查看
      </Button>
    </div>
  );
};

export default PassWord;
